import React, { ReactElement } from 'react';
import { Heading } from 'idsk-react-components';
import SearchLdapDataResultTable from './SearchLdapDataResultTable';
import LdapItem from '../../../model/LdapItem';
import './searchLdapDataResult.scss';

interface Props {
  label: string;
  searchToken: string;
  data: LdapItem[];
  setLdapItem:(ldapItem: LdapItem) => void;
  setSearchToken:(searchToken: string) => void;
  clearFieldErrorMessage: (fieldName: string) => void;
  isPouzivatel?: boolean;
}

const SearchLdapDataResult = ({
  label,
  searchToken,
  setLdapItem,
  setSearchToken,
  data,
  clearFieldErrorMessage,
  isPouzivatel,
}: Props): ReactElement => (
  <div className="search-ldap-data__result search-ldap-data__result-scrollable-div">
    {data
      && data.length > 0
      && (
        <SearchLdapDataResultTable
          isPouzivatel={isPouzivatel}
          label={label}
          setLdapItem={setLdapItem}
          data={data}
          setSearchToken={setSearchToken}
          clearFieldErrorMessage={clearFieldErrorMessage}
        />
      )}
    {(!data || data.length === 0) && (
    <div className="search-ldap-data__empty-result">
      <Heading size="s">{`Hľadaný subjekt "${searchToken}" nebol nájdený v databáze.`}</Heading>
    </div>
    )}
  </div>
);

export default SearchLdapDataResult;
